import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { WorkflowContainer } from '../components/configuration/WorkflowContainer';
import { createTaskTypeCreationConfiguration } from '../components/configuration/taskTypeCreationConfiguration';
import { useTaskTypeStore } from '../stores/useTaskTypeStore';
import { useConfigurationStore } from '../stores/useConfigurationStore';

const TaskTypeCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { addTaskType } = useTaskTypeStore();
  const { formData } = useConfigurationStore();

  const configuration = useMemo(() => createTaskTypeCreationConfiguration(), []);

  const handleComplete = async () => {
    try {
      console.log('Form Data:', formData); // 디버깅용
      
      // formData에서 작업유형 정보 추출
      const taskTypeData = {
        name: formData.name as string,
        memo: formData.description as string || '', // description을 memo로 매핑
        description: formData.description as string || '',
        workerDisplayName: formData.workerDisplayName as string || '',
        workerDisplayDescription: formData.workerDisplayDescription as string || '',
        languageDependent: formData.languageDependent as boolean || false,
        color: formData.color as string || '#6B7280',
        editorOptions: formData.editorOptions || {},
        icon: formData.icon as string || 'Settings', // 선택된 아이콘 사용
        tags: formData.tags as string[] || [], // 태그
        // order는 스토어에서 자동 계산
        // isActive는 스토어에서 자동 설정
      };

      console.log('Task Type Data:', taskTypeData); // 디버깅용

      // 작업유형 생성
      addTaskType(taskTypeData);
      
      // 작업유형 관리 페이지로 이동
      navigate('/work/task-types');
    } catch (error) {
      console.error('작업유형 생성 실패:', error);
    }
  };

  const handleCancel = () => {
    navigate('/work/task-types');
  };

  return (
    <div className="container mx-auto p-6">
      <WorkflowContainer
        configuration={configuration}
        title="작업유형 생성"
        description="새로운 작업유형을 생성합니다"
        showModeSelector={true}
        defaultViewMode="stepper"
        cancelButtonText="취소"
        completeButtonText="작업유형 생성"
        onComplete={handleComplete}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default TaskTypeCreatePage;
